const phonePlaceholder = {
  'fr-FR': 'Rechercher...',
  'en-EN': 'Search...',
  'be-EN': 'Search...',
  'be-FR': 'Rechercher...',
  'en-BE': 'Search...',
  'fr-BE': 'Rechercher...',
};

export default phonePlaceholder;
